import {TEditableColumn} from 'components/editable-table/model/types';

/**
 * Конвертирует ширину в число (пиксели)
 */
const convertWidthToNumber = (width: string | number | undefined): number => {
    if (typeof width === 'number') {
        return width;
    }
    if (typeof width === 'string') {
        const numericValue = parseInt(width.replace('px', ''), 10);
        return Number.isNaN(numericValue) ? 80 : numericValue;
    }
    return 80;
};

/**
 * Рассчитывает left позицию для fixed колонок
 * @param columns - массив всех колонок
 * @param currentColumnIndex - индекс текущей колонки
 * @param currentColumnKey - ключ текущей колонки
 * @returns left позиция в пикселях
 */
export const calculateFixedColumnLeft = (
    columns: TEditableColumn[],
    currentColumnIndex: number,
    currentColumnKey: string
): number | undefined => {
    // Если колонка не фиксированная - возвращаем undefined
    const currentColumn = columns.find(col => col.key === currentColumnKey);
    if (!currentColumn?.fixed) {
        return undefined;
    }

    let leftPosition = 0;
    columns.slice(0, currentColumnIndex).forEach((column: TEditableColumn) => {
        // Суммируем ширину только фиксированных колонок
        if (column?.fixed) {
            leftPosition += convertWidthToNumber(column.width);
        }
    })

    return leftPosition;
};